"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _primitives = require("../primitives");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO: Convert to use primitives
var ReactModalAdapter = function ReactModalAdapter(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/_react.default.createElement(_reactModal.default, _extends({
    className: "".concat(className, "__content"),
    overlayClassName: "".concat(className, "__overlay"),
    portalClassName: className
  }, props));
};

var _StyledText = (0, _styledComponents.default)(_primitives.Text).withConfig({
  displayName: "modal___StyledText",
  componentId: "sc-6i5a7g-0"
})(["padding:16px 16px 0 16px;text-transform:capitalize;margin:0;margin-top:24px;"]);

var _StyledBox = (0, _styledComponents.default)(_primitives.Box).withConfig({
  displayName: "modal___StyledBox",
  componentId: "sc-6i5a7g-1"
})(["cursor:pointer;height:44px;width:44px;position:absolute;top:0;right:0;background-color:transparent;border:none;padding-top:8px;"]);

var Modal = function Modal(_ref2) {
  var title = _ref2.title,
      children = _ref2.children,
      renderFooter = _ref2.renderFooter,
      onRequestClose = _ref2.onRequestClose,
      others = _objectWithoutProperties(_ref2, ["title", "children", "renderFooter", "onRequestClose"]);

  return /*#__PURE__*/_react.default.createElement(SC.Modal, _extends({
    ariaHideApp: false,
    onRequestClose: onRequestClose
  }, others), /*#__PURE__*/_react.default.createElement(_primitives.Box, {
    display: "relative"
  }, title && /*#__PURE__*/_react.default.createElement(_StyledText, {
    textStyle: "subheading",
    color: "black",
    textAlign: "center"
  }, title), /*#__PURE__*/_react.default.createElement(_StyledBox, {
    as: "button",
    display: "block",
    "aria-label": "close",
    onClick: function onClick() {
      return onRequestClose && onRequestClose();
    }
  }, CLOSE_BUTTON)), /*#__PURE__*/_react.default.createElement(SC.Body, {
    hasFooter: typeof renderFooter !== 'undefined'
  }, children), renderFooter && /*#__PURE__*/_react.default.createElement(SC.Footer, null, renderFooter()));
};

exports.Modal = Modal;
var SC = {};
SC.Modal = (0, _styledComponents.default)(ReactModalAdapter).withConfig({
  displayName: "modal__Modal",
  componentId: "sc-6i5a7g-2"
})(["&__overlay{position:fixed;top:0px;left:0px;right:0px;bottom:0px;height:100%;z-index:1050;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,0.42);}&__content{position:relative;box-shadow:0 2px 20px 4px rgba(0,0,0,0.14);border-radius:16px;border-color:none;background:white;max-width:80vw;max-height:98vh;overflow:auto;outline:unset;@media screen and (max-width:767px){margin-left:16px;margin-right:16px;}}"]);
SC.Body = _styledComponents.default.div.withConfig({
  displayName: "modal__Body",
  componentId: "sc-6i5a7g-3"
})(["padding:16px;@media screen and (min-width:420px){padding:24px;}", ";"], function (_ref3) {
  var hasFooter = _ref3.hasFooter;
  return hasFooter && "padding-bottom: 0;";
});
SC.Footer = _styledComponents.default.div.withConfig({
  displayName: "modal__Footer",
  componentId: "sc-6i5a7g-4"
})(["display:flex;justify-content:flex-end;margin-top:20px;padding:20px;border-top:1px solid #f8f8f8;"]);
Modal.defaultProps = {
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true
}; // https://github.com/reactjs/react-modal#api-documentation

Modal.propTypes = _objectSpread(_objectSpread({}, _reactModal.default.propTypes), {}, {
  title: _propTypes.default.string,
  onRequestClose: _propTypes.default.func
});

var CLOSE_BUTTON = /*#__PURE__*/_react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.35355 4.64645C5.15829 4.45118 4.84171 4.45118 4.64645 4.64645C4.45118 4.84171 4.45118 5.15829 4.64645 5.35355L5.35355 4.64645ZM18.6464 19.3536C18.8417 19.5488 19.1583 19.5488 19.3536 19.3536C19.5488 19.1583 19.5488 18.8417 19.3536 18.6464L18.6464 19.3536ZM4.64645 5.35355L18.6464 19.3536L19.3536 18.6464L5.35355 4.64645L4.64645 5.35355Z",
  fill: "#71747A"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.3536 5.35355C19.5488 5.15829 19.5488 4.84171 19.3536 4.64645C19.1583 4.45118 18.8417 4.45118 18.6464 4.64645L19.3536 5.35355ZM4.64645 18.6464C4.45118 18.8417 4.45118 19.1583 4.64645 19.3536C4.84171 19.5488 5.15829 19.5488 5.35355 19.3536L4.64645 18.6464ZM18.6464 4.64645L4.64645 18.6464L5.35355 19.3536L19.3536 5.35355L18.6464 4.64645Z",
  fill: "#71747A"
}));